import { defineMessages } from 'react-intl';

export const Gallery = defineMessages({
  photosNotAvailable: {
    id: 'app.Gallery.photosNotAvailable',
    defaultMessage: 'Fotky nejsou k dispozici!',
  },
});
